/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Landing_Calendar_MoreInputs */

const en_landing_calendar_more = /** @type {(inputs: Landing_Calendar_MoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} more`)
};

const pl_landing_calendar_more = /** @type {(inputs: Landing_Calendar_MoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} więcej`)
};

/**
* | output |
* | --- |
* | "{count} more" |
*
* @param {Landing_Calendar_MoreInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const landing_calendar_more = /** @type {((inputs: Landing_Calendar_MoreInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Calendar_MoreInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_landing_calendar_more(inputs)
	return en_landing_calendar_more(inputs)
});